import classNames from 'classnames';
import useResizeLayout from '@Hooks/useResizeLayout';
import { Flex, Space } from 'antd';
import { ComparisonTableTabs } from '../Tab.enum';
import { TabSelectBtn } from '../buttons';

import styles from './tab-switch.module.css';

interface TabSwitchProps {
  tab: ComparisonTableTabs | null;
  changeTab: (tab: ComparisonTableTabs) => void;
}

const TabSwitch: React.FC<TabSwitchProps> = ({ changeTab, tab }) => {
  const { isMobile } = useResizeLayout();

  return (
    <Flex flex="0 1 104px" vertical>
      <Flex justify={isMobile ? 'normal' : 'end'}>
        <Space
          className={classNames(
            'trojan-glassphormism-box',
            isMobile ? styles.tabSelectBoxMobile : styles.tabSelectBox
          )}
        >
          <TabSelectBtn
            className={isMobile ? styles.buttonTab : ''}
            active={tab === ComparisonTableTabs.Materials}
            value={ComparisonTableTabs.Materials}
            onClick={() => changeTab(ComparisonTableTabs.Materials)}
          >
            All Materials
          </TabSelectBtn>
          <TabSelectBtn
            className={isMobile ? styles.buttonTab : ''}
            value={ComparisonTableTabs.Selected}
            active={tab === ComparisonTableTabs.Selected}
            onClick={() => changeTab(ComparisonTableTabs.Selected)}
          >
            Selected
          </TabSelectBtn>
        </Space>
      </Flex>
    </Flex>
  );
};

export default TabSwitch;
